module.exports = __webpack_public_path__ + "img/hp_logo_v2.59321663.svg";